<template>
  <div>
    <h3 class="mb-5">{{crmEvent.eventlisttitleEN}}</h3>
    <p class="mb-5" v-if="crmEvent.course_no">{{crmEvent.course_no}}</p>
    <div v-if="loadingShow" class="d-flex justify-content-center mb-3">
      <span><b-spinner small class="loading-spinner mr-2"></b-spinner>Data is loading...</span>
    </div>
    <b-alert
      v-model="hasError"
      variant="danger"
      fade
    >
      {{ errorMessage }}
    </b-alert>
    <b-alert
      v-model="hasWarning"
      variant="warning"
      fade
    >
      {{ warningMessage }}
    </b-alert>
    <dx-data-grid
      v-show="dataIsLoaded"
      :ref="dataGridEvents"
      id="gridContainerEventlistDetail"
      :data-source="dataSource"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-min-width="50"
      columnResizingMode="widget"
      :show-borders="true"
      :showColumnLines="true"
      :showRowLines="true"
      key="field_001"
      :no-data-text="$t('general.noEntries')"
      :word-wrap-enabled="true"
      :column-auto-width="false"
      :hover-state-enabled="true"
      @row-updated="onUpdateRow"
      @editing-start="onEditingStart"
      @contentReady="contentReady"
      @row-expanding="openRowExpanding"
      :remote-operations="true"
      :sync-lookup-filter-values="false"
      :columns="generatedColumns"
    >

      <dx-filter-panel :visible="true"/>

      <dx-scrolling
        mode="virtual"
        row-rendering-mode="virtual"
      />
      <dx-paging :page-size="pageSize"/>

      <dx-filter-row
        :visible="true"
        apply-filter=""
      />

      <dx-header-filter
        :visible="true"
      />

      <dx-column-chooser
        :enabled="true"
        mode="select"
      >
        <dx-column-chooser-search
          :enabled="true"
        />
      </dx-column-chooser>

      <dx-search-panel
        :visible="true"
        :width="320"
        placeholder="Search..."
      />

      <dx-editing
        refresh-mode="repaint"
        :allow-updating="true"
        mode="cell"
      />

      <dx-column-fixing :enabled="true"/>

      <template #evaluation-template="{ data }">
        <div>
          <b-button
            v-for="evaluation in data.data.vLABEvaluations"
            :key="evaluation.field_001"
            pill
            size="sm"
            :variant="getPillStyle(evaluation.sEMINARCasequality.casequality)"
            class="mr-1"
          >
            <span v-if="evaluation.cRMMitarbeiter">{{evaluation.cRMMitarbeiter.vorname}}: {{evaluation.sEMINARCasequality.casequality}}</span>
          </b-button>
        </div>
      </template>
      <template #permalink-template="{ data }">
        <a v-if="data.data.cRMAddress && checkRoleId26(data.data)" :href="data.data.cRMAddress.permalink ? `https://www.startup.ch/${data.data.cRMAddress.permalink}`: ``" target="_blank">{{data.data.cRMAddress.permalink}}</a>
      </template>
      <template #pdflink-template="{ data }">
        <a :href="`https://www.venturelab.ch/index.cfm?page=137394&OUID=${data.data.unicSession}`" target="_blank">PDF</a>
      </template>
      <template #reporting-template="{ data }">
        <div v-if="data.data.cRMAddress && data.data.cRMAddress.profiles[0] && data.data.cRMAddress.profiles[0].pROFILProfilJOINReportingGroups.length">
          <span
            v-for="reportingGroup in data.data.cRMAddress.profiles[0].pROFILProfilJOINReportingGroups"
            :key="reportingGroup.reportingGroupIDId"
          >
            <span v-if="reportingGroup.pROFILReportingGroup">{{reportingGroup.pROFILReportingGroup.reportingGroups}}, </span>
            <span v-else></span>
          </span>
        </div>
        <div v-else>
          <span></span>
        </div>
      </template>
      <template #sectors-template="{ data }">
        <div v-if="data.data.cRMAddress && data.data.cRMAddress.profiles[0] && data.data.cRMAddress.profiles[0].pROFILProfilJOINCategories.length">
          <span
            v-for="(category, index) in data.data.cRMAddress.profiles[0].pROFILProfilJOINCategories"
            :key="index"
          >
            <span v-if="category.pROFILCategory">{{category.pROFILCategory.kategorieDE}}, </span>
            <span v-else></span>
          </span>
        </div>
        <div v-else>
          <span></span>
        </div>
      </template>
      <dx-master-detail
        :enabled="true"
        template="master-detail"
      />
      <template #master-detail="{ data }">
        <master-detail :masterDetailAdressId="data.data.cRMAddress.field_001" :bestellungId="data.data.field_001" :eventPoolId="crmEvent.eventpool.field_001" :sortDate="crmEvent.sortierdatum"/>
      </template>
      <dx-toolbar>
        <dx-item
          location="before"
          template="totalGroupCount"
        />
        <dx-item
          name="searchPanel"
        />
        <dx-item
          location="after"
          template="actionmenu"
        />
        <dx-item
          location="after"
          template="myColumnChooser"
        />
      </dx-toolbar>
      <template #totalGroupCount>
        <div class="informer" v-if="totalCount > 0">
          <span class="count">{{ filteredCount }} results out of {{ totalCount }} records</span>
        </div>
      </template>
      <template #actionmenu>
        <div>
          <v-menu
            offset-y
            bottom
            left
            content-class="toolbar-action-menu"
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="secondary"
                v-bind="attrs"
                v-on="on"
              >
                <i class="fas fa-cog"></i> Actions
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                link
                @click="visible = true"
              >
                <v-list-item-title><i class="fas fa-columns mr-1"></i> Column Chooser</v-list-item-title>
              </v-list-item>
              <v-tooltip left max-width="400" open-delay="500">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-list-item
                      link
                      @click="onExporting"
                      :disabled="!enableExport"
                    >
                      <v-list-item-title><i class="fas fa-file-excel mr-2"></i> Excel Export</v-list-item-title>
                    </v-list-item>
                  </span>
                </template>
                <span>For performance and security reasons, there is currently an export limit of 5000.<br>Large lists can take a few minutes to export</span>
              </v-tooltip>
              <v-tooltip left max-width="400" open-delay="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    @click="saveState"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-list-item-title><i class="fas fa-save mr-2"></i> Save Template</v-list-item-title>
                  </v-list-item>
                </template>
                <span>Save the columns template</span>
              </v-tooltip>
              <v-tooltip left max-width="400" open-delay="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    @click="loadState"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-list-item-title><i class="fas fa-download mr-2"></i> Load Template</v-list-item-title>
                  </v-list-item>
                </template>
                <span>Open a columns template</span>
              </v-tooltip>
            </v-list>
          </v-menu>
        </div>
      </template>
      <template #myColumnChooser>
        <custom-column-chooser
          :key="newRenderKey"
          container="#gridContainerEventlistDetail"
          button="#myColumnChooser"
          :isAdmin="checkAdmin(currentUser.mitarbeiterId)"
          :visible="visible"
          @call-on-hiding="onHiding"
          @call-apply="onApply"
          :columns="columns"
        />
      </template>
    </dx-data-grid>
    <save-template :template="template"/>
    <load-template :tableType="tableType" @set-state-1="loadSelectedTemplate" @set-default-state-1="loadDefaultTemplate"/>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import SaveTemplate from '@/components/template/SaveTemplate.vue'
  import LoadTemplate from '@/components/template/LoadTemplate.vue'
  import moment from 'moment'
  import { createCustomStore } from '@/store/helpers/remoteOperation.js'
  import { errorHandler } from '@/helpers/formHelper.js'
  import {
    DxDataGrid,
    DxEditing,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxHeaderFilter,
    DxFilterRow,
    DxColumnFixing,
    DxScrolling,
    DxFilterPanel,
    DxSearchPanel,
    DxPaging,
    DxToolbar,
    DxItem,
    DxMasterDetail
  } from 'devextreme-vue/data-grid'
  import {
    queryGenerator,
    calcTotalExt,
    calculateEvaluationsExt,
    calcIsDisclaimerExt,
    calcJoinedSuisseModulesExt,
    calcInnosuisseprogramsExt,
    calcDescribesyourcurrentinterestExt,
    calcUnSustainableDevelopmentGoalsExt,
    calcEventCourseCohortExt,
    calcValueByEventPoolId,
    fundraisingGoalExt,
    latestClosingDateExt,
    latestStageExt,
    calculateSectorsExt,
    calculateReportinggroupsExt,
    calculateAgeGroupExt,
    getBirthdayExt,
    getSalutationIdExt,
    getDisplayExprExt,
    getDisplayExprVKExt,
    getDisplayExprVLExt,
    getDisplayExprT100Ext,
    getDisplayExprISExt,
    getPillStyleExt
  } from '@/helpers/externalFunctions.js'
  import { calculatedColumnsManagement } from '@/components/eventV2/columnManagementHelper.js'
  import { isAdmin } from '@/helpers/auth.js'
  import { defaultcolumns } from '@/components/eventV2/columns.js'
  import MasterDetail from '@/components/eventV2/MasterDetail.vue'
  import { exportDataGrid } from 'devextreme/excel_exporter'
  import ExcelJS from 'exceljs'
  import saveAs from 'file-saver'
  import CustomColumnChooser from '@/components/eventV2/CustomColumnChooser.vue'
  import _ from 'lodash'

  const dataGridEvents = 'dataGrid'

  export default {
    components: {
      DxDataGrid,
      DxEditing,
      DxColumnChooser,
      DxColumnChooserSearch,
      DxHeaderFilter,
      DxFilterRow,
      DxColumnFixing,
      DxScrolling,
      DxFilterPanel,
      DxSearchPanel,
      DxPaging,
      DxToolbar,
      DxItem,
      CustomColumnChooser,
      DxMasterDetail,
      MasterDetail,
      SaveTemplate,
      LoadTemplate
    },
    data () {
      return {
        hasError: false,
        hasWarning: false,
        errorMessage: '',
        warningMessage: '',
        loadingShow: true,
        dataIsLoaded: false,
        template: {},
        tableType: 1,
        defaultState: null,
        dataGridEvents,
        totalCount: 0,
        filteredCount: 0,
        pageSize: 50,
        eventId: null,
        currentDate: new Date(),
        enableExport: false,
        columns: null,
        visible: false,
        basicValueLoaded: false,
        currentEditingRowData: null,
        editRowKey: '',
        newRenderKey: 1,
        eventPoolsIsCourses: [750, 751, 730, 752, 753, 754, 755, 756, 1448, 1452, 1457, 1458, 1459, 1460, 1461, 1462, 1451],
        eventPoolsIsMixed: [1443, 1443]
      }
    },
    async created () {
      const { id } = this.$route.params
      this.eventId = id
      this.crmEvent.eventlisttitleEN = ''
      this.columns = _.cloneDeep(defaultcolumns)
      this.onGetUserAdminRolle()
      this.getBasicValues('basicValues/GET_FACULTY_UNIVERSITY_TYPES', this.facultyUniversityTypes)
      this.getBasicValues('basicValues/GET_UNIVERSITY_TYPES', this.universityTypes)
      this.getBasicValues('basicValues/GET_BRANCHE_TYPES', this.brancheTypes)
      this.getBasicValues('basicValues/GET_STARTUPHASE_TYPES', this.startupPhaseTypes)
      this.getBasicValues('basicValues/GET_COUNTRY_TYPES', this.countryTypes)
      this.getBasicValues('basicValues/GET_CASEQUALITY_TYPES', this.casequalityTypes)
      this.getBasicValues('basicValues/GET_AFFIRMATION_TYPES', this.affirmationTypes)
      this.getBasicValues('basicValues/GET_RECHTSFORM_TYPES', this.rechtsformTypes)
      this.getBasicValues('basicValues/GET_LANGUAGES_TYPES', this.languagesTypes)
      this.getBasicValues('basicValues/GET_EDUCATION_TYPES', this.educationTypes)
      this.getBasicValues('basicValues/GET_CANTON_TYPES', this.cantonTypes)
      this.getBasicValues('basicValues/GET_SALUTATION_TYPES', this.salutationTypes)
      this.getBasicValues('basicValues/GET_PRIOVLAB_TYPES', this.priovlabTypes)
      this.getBasicValues('basicValues/GET_PRIOVLABXMAS_TYPES', this.priovlabxmasTypes)
      this.getBasicValues('basicValues/GET_PROFILCATEGORY_TYPES', this.profilcategoryTypes)
      this.getBasicValues('basicValues/GET_VKCASESTATUS_TYPES', this.vkCaseStatusTypes)
      this.getBasicValues('basicValues/GET_EVENT_SIGNUP_FUNKTION', this.eventSignupFunctions)
      this.getBasicValues('basicValues/GET_INVESTMENT_STAGES', this.investmentStages)
      this.getBasicValues('basicValues/GET_EVENT_STARTUP_STAGE_IS_2025', this.eventStartupStages)
      this.getBasicValues('basicValues/GET_EVENT_STARTUP_SECTORS_IS_2025', this.eventStartupSectors)
      this.getBasicValues('basicValues/GET_EVENT_INDUSTRY_EXPERIENCE_IS_2025', this.eventIndustryExperiences)
      this.getBasicValues('basicValues/GET_EVENT_STARTUP_RELATIONSHIP_UNI_IS_2025', this.eventRelationshipUnis)
      this.getBasicValues('basicValues/GET_EVENT_EMPLOYMENTSTATUS_IS_2025', this.eventEmploymentStatus)
      this.basicValueLoaded = true
      this.onGetEventById(id)
      this.initStore()
    },
    mounted () {
      this.defaultState = JSON.stringify(this.dataGrid.state())
    },
    methods: {
      initStore () {
        const key = 'field_001'
        this.dataSource = createCustomStore({ key, self: this, methodName: 'getBestellungen', root: this.$root })
      },
      async getBestellungen (gqlOptions) {
        this.hasError = false
        this.$Progress.start()
        this.loadingShow = true

        gqlOptions.eventId = Number(this.eventId)

        try {
          const completeQuery = await this.generateQuery()
          const isProfileVisible = this.columns.some(column => ((column.visible && !column.withoutQueryField) || column.internVisible) && column.isProfile)
          let profilesQuery = null
          if (isProfileVisible) {
            profilesQuery = await this.generateQueryProfiles()
          }
          const options = {
            gqlOptions,
            completeQuery,
            profilesQuery,
            isProfileVisible
          }
          const data = await this.$store.dispatch('event/GET_BESTELLUNGEN_PAGINATION_V2', {
            options
          })

          const { items, totalCount } = data.data.response

          this.totalCount = totalCount
          this.loadingShow = false
          this.dataIsLoaded = true
          this.$Progress.finish()

          return {
            data: items,
            totalCount
          }
        } catch (err) {
          errorHandler(this, err)
          console.error(err)
        }
      },
      async getBasicValues (storePath, storeValue) {
        if (storeValue.length === 0) {
          try {
            const { errors } = await this.$store.dispatch(storePath)
            if (errors) throw errors
          } catch (err) {
            this.hasError = true
            this.errorMessage = this.$t('formError.unknownwError')
            setTimeout(() => {
              this.hasError = false
            }, 5000)
          }
        }
      },
      async onGetEventById (id) {
        try {
          const { errors } = await this.$store.dispatch('event/GET_EVENT_BY_ID', { id })
          if (errors) throw errors
          document.title = 'VLAMS - ' + this.crmEvent.eventlisttitleEN
        } catch (err) {
          this.hasError = true
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      },
      async generateQuery () {
        const baseQuery = `query cRMAnmeldungBestellungensPagination (
        $order: [CRMAnmeldungBestellungSortInput!],
        $where: CRMAnmeldungBestellungFilterInput,
        $take: Int,
        $skip: Int
      ) {
          response: cRMAnmeldungBestellungensPagination (order: $order, where: $where, take: $take, skip: $skip) {
          items {`

        const finalQuery = `
              }
              totalCount
            }
          }
        `
        return queryGenerator(baseQuery, finalQuery, this.columns, false)
      },
      async generateQueryProfiles () {
        const baseQuery = `query profilesByBatchAdressId ($crmAdressIds: [Int!]!) { 
        response: profilesByBatchAdressId (crmAdressIds: $crmAdressIds) {
        `

        const finalQuery = `
          }
        }`

        return queryGenerator(baseQuery, finalQuery, this.columns, true)
      },
      contentReady () {
        this.filteredCount = this.dataGrid.totalCount()
        this.enableExport = this.filteredCount <= 5000
      },
      onEditingStart (e) {
        this.currentEditingRowData = e
        this.editRowKey = e.column.dataField
      },
      async onUpdateAddress (data) {
        try {
          const returnData = await this.$store.dispatch('event/UPDATE_ADDRESS', {
            formData: data
          })
          const errors = returnData.data.updateCRMAddress.errors
          if (errors) {
            if (returnData.data.updateCRMAddress.errors[0].code === 'SUTKRTRADEREGUID_NOT_UNIQUE') {
              this.hasError = true
              this.errorMessage = this.$t('formError.SUTkrTradeRegUID_unique')
              setTimeout(() => {
                this.hasError = false
              }, 5000)
              const actualAdressId = data.field_001
              // when sUTkrTradeRegUID is not unique, we have to reset to the old data, if there were some data.
              try {
                const savedData = await this.$store.dispatch('event/GET_SAVED_EVENTDATA_BY_ADDRESSID', {
                  id: actualAdressId
                })
                data.sUTkrTradeRegUID = savedData.data.cRMAddress.sUTkrTradeRegUID
              } catch (err) {
                console.error(err)
                data.sUTkrTradeRegUID = ''
              }
            }
          } else {
            this.hasError = false
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async onUpdateProfile (data) {
        try {
          const returnData = await this.$store.dispatch('event/UPDATE_PROFILE', {
            formData: data
          })
          const errors = returnData.data.updateProfile.errors
          if (errors) {
            if (returnData.data.updateProfile.errors[0].code === 'ONELINER_EN_MAXLENGTH_EXCEEDED') {
              this.hasError = true
              this.errorMessage = this.$t('formError.OneLinerMaxLength')
              setTimeout(() => {
                this.hasError = false
              }, 5000)
            }
          } else {
            this.hasError = false
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async onUpdateBestellung (data) {
        try {
          const { errors } = await this.$store.dispatch('event/UPDATE_BESTELLUNGEN', {
            formData: data
          })
          if (errors) throw errors
          if (!errors) {
            this.hasError = false
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async onUpdateRow (rowData) {
        const mergedData = _.merge(this.currentEditingRowData, rowData)
        rowData = mergedData
        const editedQuery = this.editRowKey.split('.')
        const isBestellungUpdate = editedQuery.includes('casequality') || editedQuery.includes('eventSignupAffirmIDId') || editedQuery.includes('eventSignupFunkionIDId') || editedQuery.includes('vENTURELAB_internal_comment')
        const isAddressUpdate = editedQuery.length === 2 && editedQuery.includes('cRMAddress')
        const isProfileUpdate = editedQuery.includes('profiles[0]')
        const isUniversityUpdate = editedQuery.includes('cRMUniFaculty')

        // handles the case, if someone has no Profile and the Onlinerfield will be edited.
        if (rowData.data.cRMAddress['profiles[0]'] && rowData.data.cRMAddress.profiles.length === 0 && editedQuery.includes('profiles[0]')) {
          this.hasError = true
          this.errorMessage = this.$t('formError.noProfile')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
        } else if (rowData.data.cRMAddress['profiles[0]'] && rowData.data.cRMAddress.profiles.length >= 0 && editedQuery.includes('profiles[0]')) {
          this.hasError = false
        }

        if (isAddressUpdate) {
          if (rowData.data.cRMAddress.priovlabId === null) {
            rowData.data.cRMAddress.priovlabId = 7
          }
          rowData.data.cRMAddress.salutationId = parseInt(rowData.data.cRMAddress.salutationId)
          if (rowData.data.cRMAddress.startupPhaseId === null) {
            rowData.data.cRMAddress.startupPhaseId = -1
          }
          if (rowData.data.cRMAddress.technologyId === null) {
            rowData.data.cRMAddress.technologyId = -1
          }
          if (rowData.data.cRMAddress.unispinoffId === null) {
            rowData.data.cRMAddress.unispinoffId = -1
          }
          if (rowData.data.cRMAddress.prioXMasId === null) {
            rowData.data.cRMAddress.prioXMasId = -1
          }
          if (rowData.data.cRMAddress.vKCaseStatus === null) {
            rowData.data.cRMAddress.vKCaseStatus = -1
          }
          if (rowData.data.cRMAddress.vKacademiclinkId === null) {
            rowData.data.cRMAddress.vKacademiclinkId = -1
          }
          if (rowData.data.cRMAddress.legalFormId === null) {
            rowData.data.cRMAddress.legalFormId = -1
          }
          if (rowData.data.cRMAddress.educationId === null) {
            rowData.data.cRMAddress.educationId = -1
          }
          if (rowData.data.cRMAddress.kantonId === null) {
            rowData.data.cRMAddress.kantonId = -1
          }
          const { cRMAddress } = rowData.data
          this.onUpdateAddress(cRMAddress)
          // after sending the -1 to the gql, write again null for the select
          if (rowData.data.cRMAddress.startupPhaseId === -1) {
            rowData.data.cRMAddress.startupPhaseId = null
          }
          if (rowData.data.cRMAddress.technologyId === -1) {
            rowData.data.cRMAddress.technologyId = null
          }
          if (rowData.data.cRMAddress.unispinoffId === -1) {
            rowData.data.cRMAddress.unispinoffId = null
          }
          if (rowData.data.cRMAddress.prioXMasId === -1) {
            rowData.data.cRMAddress.prioXMasId = null
          }
          if (rowData.data.cRMAddress.vKCaseStatus === -1) {
            rowData.data.cRMAddress.vKCaseStatus = null
          }
          if (rowData.data.cRMAddress.vKacademiclinkId === -1) {
            rowData.data.cRMAddress.vKacademiclinkId = null
          }
          if (rowData.data.cRMAddress.legalFormId === -1) {
            rowData.data.cRMAddress.legalFormId = null
          }
          if (rowData.data.cRMAddress.educationId === -1) {
            rowData.data.cRMAddress.educationId = null
          }
          if (rowData.data.cRMAddress.kantonId === -1) {
            rowData.data.cRMAddress.kantonId = null
          }
        } else if (isUniversityUpdate) {
          rowData.data.cRMAddress.universityFacultyIDId = -1
          const { cRMAddress } = rowData.data
          this.onUpdateAddress(cRMAddress)
          rowData.data.cRMAddress.universityFacultyIDId = null
        } else if (isProfileUpdate && rowData.data.cRMAddress.profiles[0]) {
          let modifiedDescriptionEn = rowData.data.cRMAddress.profiles[0].description_open_en
          let modifiedOneLinerEn = rowData.data.cRMAddress.profiles[0].oneLiner_en
          let modifiedPeopleOne = rowData.data.cRMAddress.profiles[0].pEOPLEFemaleFounders
          let modifiedPeopleTwo = rowData.data.cRMAddress.profiles[0].pEOPLEMaleFounders
          let modifiedPeopleThree = rowData.data.cRMAddress.profiles[0].peopleEPFLFac
          let modifiedPeopleFour = rowData.data.cRMAddress.profiles[0].peopleEPFLLab
          let modifiedPeopleFive = rowData.data.cRMAddress.profiles[0].peopleEPFLProf

          if (rowData.data.cRMAddress['profiles[0]'].oneLiner_en) {
            modifiedOneLinerEn = rowData.data.cRMAddress['profiles[0]'].oneLiner_en

            if (modifiedOneLinerEn.length > 60) {
              modifiedOneLinerEn = modifiedOneLinerEn.substring(0, 59)
              this.hasWarning = true
              this.warningMessage = this.$t('formError.OneLinerCuttedWarning')
              setTimeout(() => {
                this.hasWarning = false
              }, 5000)
            }
          }
          if (rowData.data.cRMAddress['profiles[0]'].description_open_en) {
            modifiedDescriptionEn = rowData.data.cRMAddress['profiles[0]'].description_open_en
          }
          if (rowData.data.cRMAddress['profiles[0]'].pEOPLEFemaleFounders || rowData.data.cRMAddress['profiles[0]'].pEOPLEFemaleFounders === null || rowData.data.cRMAddress['profiles[0]'].pEOPLEFemaleFounders === 0) {
            modifiedPeopleOne = rowData.data.cRMAddress['profiles[0]'].pEOPLEFemaleFounders
          }
          if (rowData.data.cRMAddress['profiles[0]'].pEOPLEMaleFounders || rowData.data.cRMAddress['profiles[0]'].pEOPLEMaleFounders === null || rowData.data.cRMAddress['profiles[0]'].pEOPLEMaleFounders === 0) {
            modifiedPeopleTwo = rowData.data.cRMAddress['profiles[0]'].pEOPLEMaleFounders
          }
          if (rowData.data.cRMAddress['profiles[0]'].peopleEPFLFac || rowData.data.cRMAddress['profiles[0]'].peopleEPFLFac === '') {
            modifiedPeopleThree = rowData.data.cRMAddress['profiles[0]'].peopleEPFLFac
          }
          if (rowData.data.cRMAddress['profiles[0]'].peopleEPFLLab || rowData.data.cRMAddress['profiles[0]'].peopleEPFLLab === '') {
            modifiedPeopleFour = rowData.data.cRMAddress['profiles[0]'].peopleEPFLLab
          }
          if (rowData.data.cRMAddress['profiles[0]'].peopleEPFLProf || rowData.data.cRMAddress['profiles[0]'].peopleEPFLProf === '') {
            modifiedPeopleFive = rowData.data.cRMAddress['profiles[0]'].peopleEPFLProf
          }

          const profileId = rowData.data.cRMAddress.profiles[0].field_001
          rowData.data.cRMAddress.profiles[0].oneLiner_en = modifiedOneLinerEn
          rowData.data.cRMAddress.profiles[0].description_open_en = modifiedDescriptionEn
          rowData.data.cRMAddress.profiles[0].pEOPLEFemaleFounders = modifiedPeopleOne
          rowData.data.cRMAddress.profiles[0].pEOPLEMaleFounders = modifiedPeopleTwo
          rowData.data.cRMAddress.profiles[0].peopleEPFLFac = modifiedPeopleThree
          rowData.data.cRMAddress.profiles[0].peopleEPFLLab = modifiedPeopleFour
          rowData.data.cRMAddress.profiles[0].peopleEPFLProf = modifiedPeopleFive
          const profileUpdate = {
            field_001: profileId,
            oneLiner_en: modifiedOneLinerEn,
            description_open_en: modifiedDescriptionEn,
            pEOPLEFemaleFounders: modifiedPeopleOne,
            pEOPLEMaleFounders: modifiedPeopleTwo,
            peopleEPFLFac: modifiedPeopleThree,
            peopleEPFLLab: modifiedPeopleFour,
            peopleEPFLProf: modifiedPeopleFive
          }
          this.onUpdateProfile(profileUpdate)
        } else if (isBestellungUpdate) {
          if (rowData.data.casequality === null) {
            rowData.data.casequality = -1
          }
          if (rowData.data.eventSignupAffirmIDId === null) {
            rowData.data.eventSignupAffirmIDId = -1
          }
          if (rowData.data.eventSignupFunkionIDId === null) {
            rowData.data.eventSignupFunkionIDId = -1
          }
          const { field_001 } = rowData.data /* eslint-disable-line */
          const { casequality } = rowData.data
          const { eventSignupAffirmIDId } = rowData.data
          const { eventSignupFunkionIDId } = rowData.data
          const { vENTURELAB_internal_comment } = rowData.data /* eslint-disable-line */
          const bestellungUpdate = {
            field_001: field_001,
            casequality: casequality,
            eventSignupAffirmIDId: eventSignupAffirmIDId,
            eventSignupFunkionIDId: eventSignupFunkionIDId,
            vENTURELAB_internal_comment: vENTURELAB_internal_comment
          }
          this.onUpdateBestellung(bestellungUpdate)
          // after sending the -1 to the gql, write again null for the select
          if (rowData.data.casequality === -1) {
            rowData.data.casequality = null
          }
          if (rowData.data.eventSignupAffirmIDId === -1) {
            rowData.data.eventSignupAffirmIDId = null
          }
          if (rowData.data.eventSignupFunkionIDId === -1) {
            rowData.data.eventSignupFunkionIDId = null
          }
        }
      },
      async onGetUserAdminRolle () {
        try {
          const { errors } = await this.$store.dispatch('user/GET_JOINROLLE_BY_MITARBEITER_ID', this.currentUser)
          if (errors) throw errors
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      loadDefaultTemplate () {
        this.columns = _.cloneDeep(defaultcolumns)
        this.newRenderKey++
        this.initStore()
      },
      loadSelectedTemplate (state) {
        this.dataGrid.clearFilter()
        const parsedState = JSON.parse(state)
        this.columns.forEach(col => {
          if (col.dataField !== 'cRMAddress.field_001') {
            col.visible = false
          }
        })
        parsedState.columns.forEach(savedColumn => {
          const index = this.columns.findIndex(column => column.dataField === savedColumn.dataField)
          if (index !== -1 && this.columns[index]?.dataField !== 'cRMAddress.field_001') {
            const columnToUpdate = this.columns[index]
            columnToUpdate.width = savedColumn.width ?? columnToUpdate.width
            columnToUpdate.visible = savedColumn.visible
            columnToUpdate.visibleIndex = savedColumn.visibleIndex
            columnToUpdate.sortIndex = savedColumn.sortIndex
            columnToUpdate.sortOrder = savedColumn.sortOrder
            columnToUpdate.filterType = savedColumn.filterType
            columnToUpdate.filterValues = savedColumn.filterValues
            this.columns[index] = columnToUpdate
          }
        })
        calculatedColumnsManagement(parsedState.columns, this.columns, this.columns)
        this.newRenderKey++
        this.initStore()
      },
      loadState () {
        this.$store.commit('template/SET_LOAD_TEMPLATE_STATUS', true)
      },
      saveState () {
        this.template = {
          state: JSON.stringify(this.dataGrid.state()),
          table_type: this.tableType,
          creator: this.currentUser.mitarbeiterId
        }
        this.$store.commit('template/SET_SAVE_TEMPLATE_STATUS', true)
      },
      onExporting () {
        this.$store.commit('fundings/SET_EXPORT_TOTAL_COUNT', null)
        this.$store.commit('fundings/SET_EXPORT_TOTAL_COUNT', this.totalCount)
        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Seminars')
        setTimeout(() => {
          exportDataGrid({
            component: this.dataGrid,
            worksheet: worksheet,
            autoFilterEnabled: true,
            customizeCell: ({ gridCell, excelCell }) => {
              if (gridCell.rowType === 'data') {
                if (gridCell.column.dataField === 'cRMAddress.permalink') {
                  if (gridCell.value && this.checkRoleId26(gridCell.data)) {
                    excelCell.value = { text: `https://www.startup.ch/${gridCell.value}`, hyperlink: `https://www.startup.ch/${gridCell.value}` }
                  } else {
                    excelCell.value = ''
                  }
                }
                if (gridCell.column.dataField === 'unicSession') {
                  if (gridCell.value && gridCell.data.unicSession) {
                    excelCell.value = { text: `https://www.venturelab.ch/index.cfm?page=137394&OUID=${gridCell.value}`, hyperlink: `https://www.venturelab.ch/index.cfm?page=137394&OUID=${gridCell.value}` }
                  } else {
                    excelCell.value = ''
                  }
                }
              }
            }
          }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
              saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${moment(this.currentDate).format('DD.MM.YYYY')}-${this.crmEvent.eventlisttitleEN}-Seminar.xlsx`)
            })
          })
          // this.dataGrid.cancel = true
        }, 1000)
      },
      calculateEvaluations (rowData) {
        return calculateEvaluationsExt(rowData)
      },
      getFilteredFaculties (options) {
        if (options.data && options.data.cRMAddress.cRMUniFaculty !== null) {
          return {
            store: this.facultyUniversityTypes,
            filter: options.data ? ['cRMUniUniversity.field_001', '=', options.data.cRMAddress.cRMUniFaculty.universityIDId] : null
          }
        } else {
          return {
            store: this.facultyUniversityTypes,
            filter: options.data ? ['cRMUniUniversity.field_001', '=', -1] : null
          }
        }
      },
      calcIsDisclaimer (rowData) {
        return calcIsDisclaimerExt(rowData)
      },
      calcJoinedSuisseModules (rowData) {
        return calcJoinedSuisseModulesExt(rowData)
      },
      calcInnosuisseprograms (rowData) {
        return calcInnosuisseprogramsExt(rowData)
      },
      getFirstElementIsemploymentStatusIS2025 (rowData) {
        return rowData.eVENTQuestionnaireJOINEventGlobals?.[0]?.iSemploymentStatusIS2025
      },
      getFirstElementIsWhereAttendPreviousModulesIS2025 (rowData) {
        return rowData.eVENTQuestionnaireJOINEventGlobals?.[0]?.iSWhereAttendPreviousModulesIS2025
      },
      calcDescribesyourcurrentinterest (rowData) {
        return calcDescribesyourcurrentinterestExt(rowData)
      },
      calcUnSustainableDevelopmentGoals (rowData) {
        return calcUnSustainableDevelopmentGoalsExt(rowData)
      },
      calcEventCourseCohort (rowData) {
        return calcEventCourseCohortExt(rowData)
      },
      calcIsSector2025 (rowData) {
        const isEventVal = rowData?.iSsectorIDIS2025
        const isCoursesVal = rowData.eVENTQuestionnaireJOINEventGlobals?.[0]?.iSsectorIS2025
        return calcValueByEventPoolId(rowData, this.crmEvent.eventpool?.field_001, this.crmEvent.anzeigedatum, this.eventPoolsIsCourses, this.eventPoolsIsMixed, isEventVal, isCoursesVal)
      },
      calcIsStartupStage2025 (rowData) {
        const isEventVal = rowData?.iSstartupStageIDIS2025
        const isCoursesVal = rowData.eVENTQuestionnaireJOINEventGlobals?.[0]?.iSstartupStageIS2025
        return calcValueByEventPoolId(rowData, this.crmEvent.eventpool?.field_001, this.crmEvent.anzeigedatum, this.eventPoolsIsCourses, this.eventPoolsIsMixed, isEventVal, isCoursesVal)
      },
      calcIsYearsOfIndustry2025 (rowData) {
        const isEventVal = rowData?.yearsOfIndustryExperienceIS2025
        const isCoursesVal = rowData.eVENTQuestionnaireJOINEventGlobals?.[0]?.iSyearsOfIndustryExperienceIS2025
        return calcValueByEventPoolId(rowData, this.crmEvent.eventpool?.field_001, this.crmEvent.anzeigedatum, this.eventPoolsIsCourses, this.eventPoolsIsMixed, isEventVal, isCoursesVal)
      },
      calcIsCurrentRelationship2025 (rowData) {
        const isEventVal = rowData?.iScurrentRelationshipWithTheUniIS2025
        const isCoursesVal = rowData.eVENTQuestionnaireJOINEventGlobals?.[0]?.iScurrentRelationshipWithTheUniIS2025
        return calcValueByEventPoolId(rowData, this.crmEvent.eventpool?.field_001, this.crmEvent.anzeigedatum, this.eventPoolsIsCourses, this.eventPoolsIsMixed, isEventVal, isCoursesVal)
      },
      fundraisingGoal (rowData) {
        return fundraisingGoalExt(rowData)
      },
      calcTotal (rowData) {
        return calcTotalExt(rowData)
      },
      latestClosingDate (rowData) {
        return latestClosingDateExt(rowData)
      },
      latestStage (rowData) {
        return latestStageExt(rowData)
      },
      calculateSectors (rowData) {
        return calculateSectorsExt(rowData)
      },
      calculateReportinggroups (rowData) {
        return calculateReportinggroupsExt(rowData)
      },
      calculateAgeGroup (rowData) {
        return calculateAgeGroupExt(rowData)
      },
      getBirthday (rowData) {
        return getBirthdayExt(rowData)
      },
      getSalutationId (rowData) {
        return getSalutationIdExt(rowData)
      },
      getDisplayExpr (item) {
        return getDisplayExprExt(item)
      },
      getDisplayExprVK (item) {
        return getDisplayExprVKExt(item)
      },
      getDisplayExprVL (item) {
        return getDisplayExprVLExt(item)
      },
      getDisplayExprT100 (item) {
        return getDisplayExprT100Ext(item)
      },
      getDisplayExprIS (item) {
        return getDisplayExprISExt(item)
      },
      getPillStyle (evaluationType) {
        return getPillStyleExt(evaluationType)
      },
      openRowExpanding (e) {
        e.component.collapseAll(-1)
        if (!e.component.getSelectedRowKeys().length) { e.component.selectRowsByIndexes(0) }
      },
      async onApply (changes) {
        changes.forEach((change) => {
          var column = this.columns.find(
            (column) => column.dataField === change.dataField
          )
          column.visible = change.visible
          if (change.internVisible) {
            column.internVisible = true
          }
        })
        this.visible = false
        this.initStore()
      },
      onHiding () {
        this.visible = false
      },
      createLookup (column) {
        return {
          dataSource: this[column.lookup.dataSource],
          displayExpr: column.lookup.displayExprFunction ? this[column.lookup.displayExpr] : column.lookup.displayExpr,
          valueExpr: column.lookup.valueExpr,
          allowClearing: column.lookup.allowClearing
        }
      },
      checkRoleId26 (data) {
        if (data.cRMAddress?.cRMAdresseJOINRolles) {
          return data.cRMAddress.cRMAdresseJOINRolles.find(x => x.rolle_id === 26) !== undefined
        } else {
          return false
        }
      },
      checkAdmin (id) {
        return isAdmin(id)
      }
    },
    computed: {
      generatedColumns () {
        if (this.basicValueLoaded) {
          const columns = JSON.parse(JSON.stringify(this.columns))

          return columns
            .filter((column) => column.visible)
            .map((column) => {
              const modifiedColumn = {
                ...column,
                caption: this.$t(column.caption),
                validationRules: column.validationRules,
                lookup: column.lookup ? this.createLookup(column) : null,
                calculateCellValue: column.calculateCellValue ? this[column.calculateCellValue] : undefined
              }
              return modifiedColumn
            })
        } else {
          return null
        }
      },
      ...mapGetters({
        facultyUniversityTypes: 'basicValues/FACULTY_UNIVERSITY_TYPES',
        universityTypes: 'basicValues/UNIVERSITY_TYPES',
        brancheTypes: 'basicValues/BRANCHE_TYPES',
        startupPhaseTypes: 'basicValues/STARTUPHASE_TYPES',
        crmEvent: 'event/BESTELLUNGEN',
        countryTypes: 'basicValues/COUNTRY_TYPES',
        casequalityTypes: 'basicValues/CASEQUALITY_TYPES',
        affirmationTypes: 'basicValues/AFFIRMATION_TYPES',
        rechtsformTypes: 'basicValues/RECHTSFORM_TYPES',
        languagesTypes: 'basicValues/LANGUAGES_TYPES',
        educationTypes: 'basicValues/EDUCATION_TYPES',
        cantonTypes: 'basicValues/CANTON_TYPES',
        salutationTypes: 'basicValues/SALUTATION_TYPES',
        priovlabTypes: 'basicValues/PRIOVLAB_TYPES',
        priovlabxmasTypes: 'basicValues/PRIOVLABXMAS_TYPES',
        profilcategoryTypes: 'basicValues/PROFILCATEGORY_TYPES',
        vkCaseStatusTypes: 'basicValues/VKCASESTATUS_TYPES',
        eventSignupFunctions: 'basicValues/EVENT_SIGNUP_FUNCTIONS',
        investmentStages: 'basicValues/INVESTMENT_STAGES',
        eventStartupStages: 'basicValues/EVENT_STARTUP_STAGES',
        eventStartupSectors: 'basicValues/EVENT_STARTUP_SECTORS',
        eventIndustryExperiences: 'basicValues/EVENT_INDUSTRY_EXPERIENCES',
        eventRelationshipUnis: 'basicValues/EVENT_RELATIONSHIP_UNIS',
        eventEmploymentStatus: 'basicValues/EVENT_EMPLOYMENTSTATUS'
      }),
      ...mapState({
        currentUser: state => state.user.currentUser,
        adminRolle: state => state.user.adminRolle
      }),
      dataGrid: function () {
        return this.$refs[dataGridEvents].instance
      }
    },
    watch: {
      $route (to, from) {
        const { id } = this.$route.params
        this.onGetEventById(id)
      }
    }
  }
</script>
<style>
#gridContainerEventlistDetail {
    height: 78vh;
    margin-bottom: 0;
}

.dx-datagrid{
    color:#212529;
}

.dx-datagrid-headers{
    color:#212529;
    font-weight: 600;
}

.btn-pdl {
  margin: 0 0 0 5px;
}

.card{
  border: none;
}

.card-body{
  padding: 0;
}

.toggle-infos{
  padding-bottom: 0.5rem;
}

.rounded-pill{
  padding: 0 0.5rem;
}
</style>
